var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isFooter)?_c('ul',{staticClass:"page-footer"},[_vm._m(0),_c('li',[_vm._v("产投 “义利帮” 企业服务平台")])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('li',[_c('p',[_vm._v("服务专线 0579-87586666")]),_c('p',[_vm._v("服务专线 0579-87586666")])])
}]

export { render, staticRenderFns }